import axios from 'axios'
import { UrlBase } from './config'

const apps = {}

apps.createApp = (token, { companyUuid, nameApp, prefix, baseUrl }) => {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'companies/' + companyUuid + '/apps',
      data: {
        app_name: nameApp,
        prefix,
        baseUrl
      }
    }
    axios(options)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        // notify error
        const message = error.response
        if (!message) {
          return reject(new Error(error.message))
        } else {
          return reject(new Error(message.data.error))
        }
      })
  })
}

apps.createCustomExtradata = async (token, companyId, appId, data) => {
  try {
    const { extraDataArray } = data
    const request = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: `${UrlBase}companies/${companyId}/apps/${appId}/extraDataCustom`,
      data: { extraDataArray }
    }
    const response = await axios(request)
    return response.data.extraData
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

apps.deleteCustomExtradata = async (token, companyId, appId, data) => {
  try {
    const { id, name, deleteFromAllUsers } = data
    const request = {
      method: 'DELETE',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: `${UrlBase}companies/${companyId}/apps/${appId}/extraDataCustom/dataKey/${id}`,
      data: { name, deleteFromAllUsers }
    }

    const response = await axios(request)
    return response.data.extraData
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

apps.getApp = (token, companyId, uuid, data) => {
  const { getStatistics } = data
  return new Promise((resolve, reject) => {
    const options = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      params: { getStatistics },
      url: UrlBase + 'companies/' + companyId + '/apps/' + uuid
    }
    axios(options)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        console.log(error)
      })
  })
}

apps.getAppCustomExtradatas = async (token, companyId, appId) => {
  try {
    const request = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: `${UrlBase}companies/${companyId}/apps/${appId}/extraDataCustom`
    }

    const response = await axios(request)
    return response.data.extraData
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

apps.getApps = (token, companyId) => {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'companies/' + companyId + '/apps'
    }
    axios(options)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        console.log(error)
      })
  })
}

apps.getAppsStatistics = (token, companyId, appId, params) => {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId
    }
    if (params) {
      options.params = params
    }
    axios(options)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        console.log(error)
      })
  })
}

apps.getInstagramUsersLikings = (token, companyId, appId, search) => {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      params: {
        searchName: search
      },
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/likings'
    }
    axios(options)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        if (error.message !== 'Operation canceled') console.log(error)
      })
  })
}

apps.getUsersSpotifyTopGenres = (token, companyId, appId, search) => {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      params: {
        searchName: search
      },
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/spotify/top/genres'
    }
    axios(options)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        if (error.message !== 'Operation canceled') console.log(error)
      })
  })
}

apps.getUsersSpotifyTopArtists = (token, companyId, appId, search) => {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      params: {
        searchName: search
      },
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/spotify/top/artists'
    }
    axios(options)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        if (error.message !== 'Operation canceled') console.log(error)
      })
  })
}

apps.getUsersSpotifyTopTracks = (token, companyId, appId, search) => {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      params: {
        searchName: search
      },
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/spotify/top/tracks'
    }
    axios(options)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        if (error.message !== 'Operation canceled') console.log(error)
      })
  })
}

apps.invite = (token, companyId, appId, users) => {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/invite',
      data: {
        invitations: users
      }
    }
    axios(options)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        const message = error.response
        if (!message) {
          return reject(new Error(error.message))
        } else {
          return reject(new Error(message.data.error))
        }
      })
  })
}

apps.updateApp = (token, companyId, appId, data) => {
  const { appName, baseUrl, color, email, extradata, mandrillKey, photo, prefix, redirectUrl, slug } = data
  return new Promise((resolve, reject) => {
    const options = {
      method: 'PUT',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId,
      data: { app_name: appName, baseUrl, color, email, extradata, mandrillKey, photo, prefix, redirectUrl, slug }
    }
    axios(options).then(response => {
      resolve(response.data)
    }).catch(e => {
      const message = e.response
      if (!message) throw new Error(e.message)
      else throw new Error(message.data.error)
    })
  })
}

apps.updateCustomExtradata = async (token, companyId, appId, data) => {
  try {
    const { access, id, name, options, type, tags, visibleOnSearch } = data
    const request = {
      method: 'PUT',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: `${UrlBase}companies/${companyId}/apps/${appId}/extraDataCustom/dataKey/${id}`,
      data: { access, name, type, visibleOnSearch }
    }

    if (type !== 'text') request.data.options = options
    if (tags.length !== 0) request.data.tags = tags

    const response = await axios(request)
    return response.data.extraData
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

apps.getAppTagsCustomExtradatas = async (token, companyId, appId) => {
  try {
    const request = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: `${UrlBase}companies/${companyId}/apps/${appId}/extraDataCustom/tags`
    }

    const response = await axios(request)
    return response.data.tags
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

apps.getAppModules = async (token, companyId, appId) => {
  try {
    const request = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: `${UrlBase}companies/${companyId}/apps/${appId}/modules`
    }

    const response = await axios(request)
    return response.data.modules
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

export default apps
